module.exports = __webpack_public_path__ + "static/media/empty-pipeline@3x.1ca4cb80.png";